import React from "react";

export default function StaticUnregistered(props) {

    return (

		<div className="nutritionists-list">
            <div className="row" style={{display:"flex", flexWrap:"wrap",gap:20}}>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Craig McDonald</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Instagram:</div>
                            <div style={{width:190, display:"flex", alignItems: "center", fontSize:"17px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>@iamcraigmcdonald</div>
                            </div>
                        </div>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Website:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "12px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>https://www.nustrength.com.au</div>
                            </div>
                        </div>
                        <div>
                            <div className="country meta-data" style={{display:"flex"}}><em className="fa fa-globe" aria-hidden="true"
                                    style={{marginLeft:-2, padding: "3px 3px 0px 0px"}}></em>
                                <div style={{minWidth:110, fontWeight: "bold"}}>Country:</div>
                                <div style={{width:185, fontSize: "18px"}}>
                                    <div style={{display:"block", whiteSpace:"nowrap"}}>Australia</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Reilly Meyer</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Instagram:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "18px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>@ramcoaching</div>
                            </div>
                        </div>
                        <div>
                            <div className="country meta-data" style={{display:"flex"}}><em className="fa fa-globe" aria-hidden="true"
                                    style={{marginLeft:-2, padding: "3px 3px 0px 0px"}}></em>
                                <div style={{minWidth:110, fontWeight: "bold"}}>Country:</div>
                                <div style={{width:185, fontSize: "18px"}}>
                                    <div style={{display:"block", whiteSpace:"nowrap"}}>Australia</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Sharman Vickery</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Instagram:</div>
                            <div style={{width:190, display: "flex", alignItems: "center", fontSize: "13px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>@sharmanvickerycoaching</div>
                            </div>
                        </div>
                        <div>
                            <div className="country meta-data" style={{display:"flex"}}><em className="fa fa-globe" aria-hidden="true"
                                    style={{marginLeft:-2, padding: "3px 3px 0px 0px"}}></em>
                                <div style={{minWidth:110, fontWeight: "bold"}}>Country:</div>
                                <div style={{width:185, fontSize: "18px"}}>
                                    <div style={{display:"block", whiteSpace:"nowrap"}}>Australia</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Nicole Kovacic</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Website:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "8px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>https://www.elev8mma.com.au/nicole_kovacic
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="country meta-data" style={{display:"flex"}}><em className="fa fa-globe" aria-hidden="true"
                                    style={{marginLeft:-2, padding: "3px 3px 0px 0px"}}></em>
                                <div style={{minWidth:110, fontWeight: "bold"}}>Country:</div>
                                <div style={{width:185, fontSize: "18px"}}>
                                    <div style={{display:"block", whiteSpace:"nowrap"}}>Australia</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Ellanor Warner</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Website:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>https://www.sugdenimpact.com</div>
                            </div>
                        </div>
                        <div>
                            <div className="country meta-data" style={{display:"flex"}}><em className="fa fa-globe" aria-hidden="true"
                                    style={{marginLeft:-2, padding: "3px 3px 0px 0px"}}></em>
                                <div style={{minWidth:110, fontWeight: "bold"}}>Country:</div>
                                <div style={{width:185, fontSize: "18px"}}>
                                    <div style={{display:"block", whiteSpace:"nowrap"}}>Australia</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Harley Sugden</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Website:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>https://www.sugdenimpact.com</div>
                            </div>
                        </div>
                        <div>
                            <div className="country meta-data" style={{display:"flex"}}><em className="fa fa-globe" aria-hidden="true"
                                    style={{marginLeft:-2, padding: "3px 3px 0px 0px"}}></em>
                                <div style={{minWidth:110, fontWeight: "bold"}}>Country:</div>
                                <div style={{width:185, fontSize: "18px"}}>
                                    <div style={{display:"block", whiteSpace:"nowrap"}}>Australia</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Kerry Rowen</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Instagram:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap", fontSize:".7em"}}>https://www.instagram.com/the_muscle_barbie</div>
                            </div>
                        </div>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Facebook:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap", fontSize:".7em"}}>https://www.facebook.com/kerry.rowen</div>
                            </div>
                        </div>
                    </div>
                </div>

                
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Chloe Henry</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Website:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap",fontSize: ".75em"}}>https://www.evolvetrainingandnutrition.com/team-3</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Felicity Kerslake</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Website:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap",fontSize: ".8em"}}>https://www.allnaturalmedicine.com.au/about-us</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Chanel Stuck</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Website:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>https://chanelstuck.com</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Michael Philp</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Website:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap",fontSize: ".65em"}}>https://www.goodlife.com.au/personal-trainers/michael-philp</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Samantha Wolfe</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Instagram:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>https://www.instagram.com/samanthawolfexx</div>
                            </div>
                        </div>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Instagram:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>https://www.instagram.com/wolfe.strength</div>
                            </div>
                        </div>
                    </div>
                </div>

                
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Ty Dansie</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Website:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>https://www.instagram.com/the.altered.beast</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Ethan Wood-Stribley</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Website:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>https://www.instagram.com/ethan_ctrl.coaching</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Jessica Harris</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Instagram:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap",fontSize: ".85em"}}>https://www.instagram.com/jessieharrisfitness</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Fiona Brady</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Website:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap",fontSize: ".45em"}}>https://www.thecubegym.com.au/teams/fiona-brady</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Bryce Anson</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Website:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap",fontSize: ".8em"}}>https://rechargedpt.com.au/sports-nutrition-plans</div>
                            </div>
                        </div>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Website:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap", fontSize:".45em"}}>https://rechargedpt.com.au/best-fitness-center-near-me/best-fitness-trainer-near-me</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Damien Adams</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Website:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap",fontSize: ".9em"}}>https://www.compedge.com.au/home#online</div>
                            </div>
                        </div>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Instagram:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap",fontSize: ".75em"}}>https://www.instagram.com/compedgeperformance</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Kai Allison</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Instagram:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>https://www.instagram.com/kaiallisonn</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nutritionist nutri-post ei1 odd first unregistered">
                    <div className="block" style={{display:"flex", flexDirection:"column"}}>
                        <h3>
                            <div style={{textAlign:"center", fontSize:"24px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap"}}>Charlotte Robinson</div>
                            </div>
                        </h3>
                        <div className="suburb meta-data" style={{display:"flex"}}><i className="fab fa-instagram"
                                style={{padding: "3px 3px 0px 0px"}}></i>
                            <div style={{minWidth:110, fontWeight: "bold"}}>Instagram:</div>
                            <div style={{width: 190, display: "flex", alignItems: "center", fontSize: "11px"}}>
                                <div style={{display:"block", whiteSpace:"nowrap",fontSize: ".9em"}}>https://www.instagram.com/thrivenutritionco</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	);
}